import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import * as AuthActions from '../actions/user.actions';
import * as fromAuth from '../reducers';
import {AbstractAuthGuardService} from './abstract-auth-guard.service';

@Injectable()
export class AuthenticatedAuthGuardService extends AbstractAuthGuardService {
    constructor(protected store: Store<fromAuth.AuthState>) {
        super();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const url = state.url;
        console.log('Start AuthenticatedAuthGuard for', url);

        return this.determineIsLoggedIn().pipe(
            map(isLoggedIn => {
                if (!isLoggedIn) {
                    console.log('AuthenticatedAuthGuard:: The component can\'t be activated. not logged in', url);
                    this.store.dispatch(AuthActions.accessDenied({requestedUrl: url}));
                } else {
                    console.log('AuthenticatedAuthGuard:: The component can be activated', url);
                }
                return isLoggedIn;
            }),
            take(1)
        );
    }
}
